module.exports = __webpack_public_path__ + "static/img/bg_tw.9f34f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_tw.png
// module id = JYAu
// module chunks = 1